function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Flex } from "../../flex";
import { getHeaderBaseStyle } from "./List.styles";
export var ListHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref,
    alignItems: "baseline",
    px: 4,
    py: 2,
    width: "100%",
    _getBaseStyle: getHeaderBaseStyle
  }, props), props.children);
});